'use strict';
import * as $j_app$002edata$002etypes$005fpharmacy$0024package$0024$002dPharmacy$002dId$0024 from "./app.data.types_pharmacy$package$-Pharmacy-Id$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AppRegisteredUser$$anon$20() {
}
export { $c_Lapp_data_AppRegisteredUser$$anon$20 as $c_Lapp_data_AppRegisteredUser$$anon$20 };
$c_Lapp_data_AppRegisteredUser$$anon$20.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AppRegisteredUser$$anon$20.prototype.constructor = $c_Lapp_data_AppRegisteredUser$$anon$20;
/** @constructor */
function $h_Lapp_data_AppRegisteredUser$$anon$20() {
}
export { $h_Lapp_data_AppRegisteredUser$$anon$20 as $h_Lapp_data_AppRegisteredUser$$anon$20 };
$h_Lapp_data_AppRegisteredUser$$anon$20.prototype = $c_Lapp_data_AppRegisteredUser$$anon$20.prototype;
$c_Lapp_data_AppRegisteredUser$$anon$20.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_data_AppRegisteredUser$$anon$20.prototype.apply__O = (function() {
  return $j_app$002edata$002etypes$005fpharmacy$0024package$0024$002dPharmacy$002dId$0024.$m_Lapp_data_types\uff3fpharmacy$package$PharmacyId$().given_Schema_Type__Lsttp_tapir_Schema();
});
var $d_Lapp_data_AppRegisteredUser$$anon$20 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AppRegisteredUser$$anon$20, "app.data.AppRegisteredUser$$anon$20", ({
  Lapp_data_AppRegisteredUser$$anon$20: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_data_AppRegisteredUser$$anon$20 as $d_Lapp_data_AppRegisteredUser$$anon$20 };
//# sourceMappingURL=app.data.-App-Registered-User$$anon$20.js.map
